<template>
  <div style="padding-bottom: 20px;">
    <div style="padding: 20px;">
      <p v-if="previewURL && !onlyPreview">
        <b>[ Preview URL ] :</b> <a :href="previewURL">{{previewURL}}</a>
      </p>
    </div>
    <center>
      <p style="line-height:1;">
        <v-icon v-if="!onlyPreview" small style="margin-right: 10px;" color="red">mdi-alert</v-icon>
        <small v-if="!onlyPreview" style="color: orange;"><b>
          Esto es un PROTOTIPO y se encuentra en DESARROLLO !!! <br/> [ uso ORIENTATIVO ]
        </b></small></p>
        <v-progress-linear
          v-if="loadingData"
          indeterminate
          color="primary"
        />
      <div>
        <div v-if="!onlyPreview && isDev && config">
          <div 
            v-for="item of config.zones" 
            style="padding: 20px"
            :key="item.ID"
          >
            <p>{{item.zoneID}}</p>
            <p>{{item.zoneName}}</p>
            <p>{{JSON.stringify(item, null, 4)}}</p>
            <br />
            <br />
            <br />
            <br />
            <br />
          </div>
        </div>
        <preview
          v-if="config"
          :config="config"
        />
      </div>
      <!--div v-if="!onlyPreview && !loadingData && isDev && config">
        <v-btn
          v-if="config"
          @click="handleGetPreviewData"
        >
          test
        </v-btn>
        <preview
          v-if="medias && config"
          :config="config"
          :medias="medias"
        />
      </div>
              <v-card
        v-if="!onlyPreview && zones"
                elevation="2"
                class="main-template-preview" 
                :style="{ width: `${!isVertical ? width : getSize(presentationHeight)}px` }"
              >
                <div 
                  :style="{ backgroundColor: '#CCCCCC80', width: `${!isVertical ? width : getSize(presentationHeight)}px`, height: `${!isVertical ? getSize(presentationHeight) : width}px`}"
                >
                  <zone
                    v-for="(zone, index) of zones"
                    :key="`${item.ID}${zone.ID}`"
                    :backgroundColor="prepareColor(zone.ID, zone.PrevColor)"
                    :color="prepareTextColor(zone.ID)"
                    :fontSize="`${prepareTextSize(zone.ID)}px`"
                    :top="`${getSize(zone.Top)}px`"
                    :right="`${getSize(zone.Right)}px`"
                    :width="isVertical ? `${getSize(zone.Height)}px` : `${getSize(zone.Width)}px`"
                    :height="isVertical ? `${getSize(zone.Width)}px` : `${getSize(zone.Height)}px`"
                    :originalWidth="isVertical ? `${zone.Height}px` : `${zone.Width}px`"
                    :originalHeight="isVertical ? `${zone.Width}px` : `${zone.Height}px`"
                    :scaleFactor="0.84"
                    :speedFactor="speedFactor"
                    :xmls="prepareXML(zone.ID)"
                    :zone="zone"
                    :style="{ 
                              border: showInfo ? '1px solid red' : null,
                              'z-index': index 
                            }"
                    :showInfo="showInfo"
                  />
                </div>
              </v-card-->
            </center>
  </div>
</template>
<script>
import apiBrightsign from '@/services/apiBrightsign'
//import Zone from './Zone'
import Preview from './preview/Index'
export default {
  components: {
  //  Zone,
    Preview,
  }, 
  props: {
    item: {
      type: Object,
      required: true,
    },
    network: {
      type: String,
      requried: true,
    },
    onlyPreview: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    config: null,
    loadingData: false,
    loading: false,
    zones: null,
    zonesNew: null,
    isVertical: false,
    speedFactor: 1,
    showInfo: false,
    presentationWidth: null,
    presentationHeight: null,
    medias: null,
    previewURL: null,
    bs: null,
  }),
  computed: {
    isDev () {
      return process.env.VUE_APP_ENV === 'development' ? true : false
    },
    width () {
      return 800
    },
    speedFactors () {
      return [
        {
          id: 0.5,
          name: 0.5,
        },
        {
          id: 0.75,
          name: 0.75,
        },
        {
          id: 1,
          name: 'normal',
        },
        {
          id: 1.25,
          name: 1.25,
        },
        {
          id: 1.5,
          name: 1.5,
        },
        {
          id: 1.75,
          name: 1.75,
        },
        {
          id: 2,
          name: 2,
        },
      ]
    },
  },
  watch: {
    'item.ID' () {
      this.handleGetPreviewData()
    },
  },
  mounted () {
    this.handleBSPreview()
    this.handleGetPreviewData()
  },
  methods: {
    convertSize (v) {
      if (!v) return v
      if (typeof v === 'string') return v.replace('px', '') | 0
      return v
    },
    calcSize (width, presentationWidth, v) {
      //const aux = (width * v) / presentationWidth//1920
      const aux = (width * this.convertSize(v)) / presentationWidth//1920
      return `${aux}px`
    },
    async handleBSPreview () {
      try {
        this.bs = await new Promise((resolve, reject) => apiBrightsign.getItem(`/v1/private/presentations/${this.network}/${this.item.ID}/bs`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          }))
      } catch (error) {
        console.log(error)
        return null
      }
    },
    async handleGetPreviewData () {
      try {
        this.loading = true
        this.config = null
        this.zones = null
        this.zonesNew = null
        this.isVertical = false
        this.loadingData = true
        apiBrightsign.getAll(`/v1/private/presentations/${this.item.ID}/contents`)
          .then(response => {
            this.medias = response
          })
          .catch(error => {
            console.log(error)
          })
        const config = await new Promise((resolve, reject) => apiBrightsign.getAll(`/v1/private/presentations/${this.item.ID}/preview-data-new`)
          .then(response => {
            if (!response) return
            const pSize = response.presentationSize

            const presentationWidth = pSize && pSize.width ? pSize.width : 1920
            const presentationHeight = pSize && pSize.height ? pSize.height : 1080
            response.presentationID = this.item.ID
            response.width = !response.vertical ? this.width : this.calcSize(this.width, presentationWidth, presentationHeight)
            response.height = !response.vertical ? this.calcSize(this.width, presentationWidth, presentationHeight) : this.width
            response.originalWidth = response.vertical ? presentationHeight : presentationWidth
            response.originalHeight = response.vertical ? presentationWidth : presentationHeight

            if (response.zones) {
              response.zones = response.zones.filter(x => ['EnhancedAudio', 'AudioOnly'].indexOf(x.zoneType) < 0)
              const result = []
              const messages = response.zones.filter(x => x.zoneType === 'Ticker')
              response.zones = response.zones.filter(x => x.zoneType !== 'Ticker')
              result.push(...response.zones.filter(x => !x.html || x.html.length === 0).map(item => {
                item.originalWidth = response.vertical ? item.height : item.width
                item.originalHeight = response.vertical ? item.width : item.height
                item.originalTop = item.top
                item.originalRight = item.right
                item.top = this.calcSize(this.width, presentationWidth, item.top)
                item.right = this.calcSize(this.width, presentationWidth, item.right)
                const tmpWidth = response.vertical ? this.calcSize(this.width, presentationWidth, item.height) : this.calcSize(this.width, presentationWidth, item.width)
                const tmpHeight = response.vertical ? this.calcSize(this.width, presentationWidth, item.width) : this.calcSize(this.width, presentationWidth, item.height)
                item.width = tmpWidth //response.vertical ? this.calcSize(this.width, presentationWidth, item.height, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.width)
                item.height = tmpHeight//response.vertical ? this.calcSize(this.width, presentationWidth, item.width, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.height)
                return item
              }))
              result.push(...response.zones.filter(x => x.html && x.html.length > 0).map(item => {
                item.originalWidth = response.vertical ? item.height : item.width
                item.originalHeight = response.vertical ? item.width : item.height
                item.originalTop = item.top
                item.originalRight = item.right
                item.top = this.calcSize(this.width, presentationWidth, item.top)
                item.right = this.calcSize(this.width, presentationWidth, item.right)
                const tmpWidth = response.vertical ? this.calcSize(this.width, presentationWidth, item.height) : this.calcSize(this.width, presentationWidth, item.width)
                const tmpHeight = response.vertical ? this.calcSize(this.width, presentationWidth, item.width) : this.calcSize(this.width, presentationWidth, item.height)
                item.width = tmpWidth //response.vertical ? this.calcSize(this.width, presentationWidth, item.height, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.width)
                item.height = tmpHeight//response.vertical ? this.calcSize(this.width, presentationWidth, item.width, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.height)
                return item
              }))
              if (messages.length > 0)
                result.push(...messages.map(item => {
                  item.originalWidth = response.vertical ? item.height : item.width
                  item.originalHeight = response.vertical ? item.width : item.height
                  item.originalTop = item.top
                  item.originalRight = item.right
                  item.top = this.calcSize(this.width, presentationWidth, item.top)
                  item.right = this.calcSize(this.width, presentationWidth, item.right)
                  const tmpWidth = response.vertical ? this.calcSize(this.width, presentationWidth, item.height) : this.calcSize(this.width, presentationWidth, item.width)
                  const tmpHeight = response.vertical ? this.calcSize(this.width, presentationWidth, item.width) : this.calcSize(this.width, presentationWidth, item.height)
                  item.width = tmpWidth //response.vertical ? this.calcSize(this.width, presentationWidth, item.height, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.width)
                  item.height = tmpHeight//response.vertical ? this.calcSize(this.width, presentationWidth, item.width, item.zoneID === '9') : this.calcSize(this.width, presentationWidth, item.height)
                  return item
                }))
              response.zones = result
            }
            resolve(response)
            /*
            for (const item of response) {
              console.log('zone'+item.ID, item)
            }
            this.isVertical = response.map(item => item.Vertical).shift() ? true : false
            const pSize = response.map(item => item.PresentationSize).shift()

            this.presentationWidth = pSize && pSize.width ? pSize.width : 1920
            this.presentationHeight = pSize && pSize.height ? pSize.height : 1080

            //todo is vertical remove IMAGEN VERTICAL (screenshot)
            if (this.isVertical) {
              response = response.filter(x => x.Name !== 'IMAGEN VERTICAL')
            }
            
            const aux = []
            aux.push(...response.filter(x => x.SendToBack).sort((a,b) => {
              return a.ORD-b.ORD
            }))
            response = response.filter(x => !x.SendToBack)
            aux.push(...response.filter(x => !x.IsHTML).sort((a,b) => {
              return a.ORD-b.ORD
            }))
            aux.push(...response.filter(x => x.IsHTML).sort((a,b) => {
              return a.ORD-b.ORD
            }))
            this.zones = aux
            //console.log(this.zones.map(item => {return { height: item.Height,color: item.Color ? item.Color : 'transparent',name: item.Name, sb: item.SendToBack, h: item.IsHTML}}))
            this.loading = false
            */
          })
          .catch(error => {
            reject(error)
          }))

        for (let item of config.zones) {
          if (item && item.image && item.image.name) {
            item.background = await new Promise((resolve, reject) => apiBrightsign.getAll(`/v1/private/brightsign/${this.network}/contents/${item.image.name}`)
              .then(response => {
                resolve(response.map(item => item.physicalPath).shift())
              })
              .catch(error => {
                reject(error)
              }))
          }
          if (item.states && item.states.items) {
            for (let state of item.states.items) {
              if (state.image && state.image.name) {
                state.background = await new Promise((resolve, reject) => apiBrightsign.getAll(`/v1/private/brightsign/${this.network}/contents/${state.image.name}`)
                  .then(response => {
                    resolve(response.map(item => item.physicalPath).shift())
                  })
                  .catch(error => {
                    reject(error)
                  }))
                console.log(state.background)
              }
            }
          }
        }
        this.config = config
        this.preparePreviewURL(this.config)
        this.loadingData = false
        /*

        const url =  `/v1/private/presentations/${this.item.ID}/preview-data`
        apiBrightsign.getAll(url)
          .then(response => {
            this.isVertical = response.map(item => item.Vertical).shift() ? true : false
            const pSize = response.map(item => item.PresentationSize).shift()

            this.presentationWidth = pSize && pSize.width ? pSize.width : 1920
            this.presentationHeight = pSize && pSize.height ? pSize.height : 1080

            //todo is vertical remove IMAGEN VERTICAL (screenshot)
            if (this.isVertical) {
              response = response.filter(x => x.Name !== 'IMAGEN VERTICAL')
            }
            
            const aux = []
            aux.push(...response.filter(x => x.SendToBack).sort((a,b) => {
              return a.ORD-b.ORD
            }))
            response = response.filter(x => !x.SendToBack)
            aux.push(...response.filter(x => !x.IsHTML).sort((a,b) => {
              return a.ORD-b.ORD
            }))
            aux.push(...response.filter(x => x.IsHTML).sort((a,b) => {
              return a.ORD-b.ORD
            }))
            this.zones = aux
            //console.log(this.zones.map(item => {return { height: item.Height,color: item.Color ? item.Color : 'transparent',name: item.Name, sb: item.SendToBack, h: item.IsHTML}}))
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      */
      } catch (error) {
        console.log(error)
      }
    },
    getSpeedFactorName (v) {
      return this.speedFactors.filter(x => x.id === v).map(item => item.name).shift()
    },
    getSize (v) {
      return (this.width * v) / this.presentationWidth//1920
    },
    preparePreview () {
      this.template = this.templates.filter(x => x.ID === this.templateID).shift()
    },
    prepareColor (id) {
      return this.zones.filter(x => x.Zone === id).map(item => item.Color ? `#${item.Color}` : 'transparent').shift()
    },
    prepareTextColor (id) {
      return this.zones.filter(x => x.Zone === id).map(item => item.TextColor ? `#${item.TextColor}` : 'transparent').shift()
    },
    prepareTextSize (id) {
      const aux = this.zones.filter(x => x.Zone === id).map(item => item.TextSize).shift()
      return this.getSize(aux) * 0.7
    },
    prepareXML (id) {
      const aux = this.zones.filter(x => x.Zone === id).map(item => item.XML).shift()
      return aux ? aux.split(';') : []
    },
    preparePreviewURL (v) {
      apiBrightsign.prepareExternalToken({ network: this.network, id: v.presentationID})
        .then (response => {
          this.previewURL = this.isDev ? `http://localhost:8005/#/players/bs/preview/${response}` : `https://www.dview.es/#/players/bs/preview/${response}`
        })
    },
  },
}
</script>
